import * as React from 'react';
import { Badge } from '@emorg-prd/standard-react';
import { Button, Table, Icon } from '../common';
import moment from 'moment';
import Feedback from '../../models/entities/Feedback';
import './FeedbackHome.css';
import { useState, useEffect } from 'react';

interface FeedbackHomeTableRowProps {
	feedback: Feedback;
	setUpdateFeedbackModalVisible: any;
	setSelectedFeedback: any;
	isSSPDev: boolean;
 }

const FeedbackHomeTableRow = ({feedback, setUpdateFeedbackModalVisible, setSelectedFeedback, isSSPDev} : FeedbackHomeTableRowProps) => {
	const [date, setDate] = useState<String>('');
	const [status, setStatus] = useState<String>(feedback.workItemState?.name);
	type BadgeType = 'em-c-badge--positive' | 'em-c-badge--caution' | 'em-c-badge--negative' | undefined;
	const [badgeColor, setBadgeColor] = useState<BadgeType>('em-c-badge--positive');

	const defineBadgecolor = () => {
		if (feedback.workItemState === null) {
			setBadgeColor('em-c-badge--caution');
			setStatus('Unknown');
		} else if (status === 'Committed' || status === 'In Progress' || status === 'To Do') {
			setBadgeColor('em-c-badge--caution');
		} else if (status === 'Rejected' || status === 'Removed') {
			setBadgeColor('em-c-badge--negative');
		} else if (status === 'Approved' || status === 'New') {
			setBadgeColor(undefined);
		}
	}

	useEffect(() => {
		setDate(moment(feedback.submitDate).format('MM/DD/YYYY'));
		defineBadgecolor();
	}, []);
	
	return (
		<Table.Row key={feedback.id}>
			<Table.Cell><span className="table__cell-xs">{feedback.id}</span></Table.Cell>
			<Table.Cell>
				<Badge type={badgeColor} optionalClass="small-margin em-u-width-100" text={String(status)} />
			</Table.Cell>
			<Table.Cell><span className="table__cell-l">{feedback.title}</span></Table.Cell>
			<Table.Cell><span className="table__cell-m">{feedback.category.name}</span></Table.Cell>
			<Table.Cell><span className="table__cell-xl">{feedback.description}</span></Table.Cell>
			<Table.Cell><span className="table__cell-m">{feedback.submittedBy.displayName}</span></Table.Cell>
			<Table.Cell><span className="table__cell-m">{date}</span></Table.Cell>
			<Table.Cell>
				<Button
					onClick={() => {
						setUpdateFeedbackModalVisible(true);
						setSelectedFeedback(feedback);
					}}
					variant="secondary"
					size="small"
				>
					{isSSPDev ? <Icon icon="pencil" size="small" /> : <Icon icon="visibility-on" size="small" />}
				</Button>
			</Table.Cell>
		</Table.Row>
	);
}

export default FeedbackHomeTableRow;